import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';
import {
  REMOVE_ORGANISATION_CONTACT_RESOURCE,
  ORGANISATION_CONTACTS_RESOURCE,
} from '../../constants';
import { createErrorMessage } from '../../../app/helpers/createErrorMessage';

const RemoveOrganisationContactService = ComposedComponent =>
  reduxFetch([
    {
      resource: REMOVE_ORGANISATION_CONTACT_RESOURCE,
      method: 'delete',
      request: (orgId, id, callback, t) => ({
        url: apiRoutes.organisationContacts(orgId, id),
        meta: {
          callback,
          removeFromOtherList: {
            resource: ORGANISATION_CONTACTS_RESOURCE,
            idProp: 'id',
            id,
          },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'removeContactFailed'),
            onSuccessMessage: t('removeContactSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default RemoveOrganisationContactService;
